import { FC } from 'react';
import { IonList } from '@ionic/react';
import { AppPage } from '../../../hooks/useRoutes';
import { MenuAccordion } from './MenuAccordion';
import { MenuItem } from './MenuItem';

export const Menu: FC<{
  pages: AppPage[];
  level?: number;
  hasMultipleLevels?: boolean;
  shouldResetMenu?: boolean;
  expanded: boolean;
}> = ({ pages, level = 0, hasMultipleLevels = false, shouldResetMenu = false, expanded }) => (
  <IonList mode="md" className={`list-menu  ${level === 1 ? 'scrollable' : ''}`}>
    {pages.map((page, index) => {
      const hasChildren = page.children && page.children.length > 0;
      const deeperLevelsExist = hasMultipleLevels || (level > 0 && hasChildren);

      return page.children && page.children.length > 0 ? (
        <MenuAccordion
          key={`menu-accordion-level-${level}-${index}`}
          page={page}
          isLast={!hasChildren}
          level={level}
          shouldResetMenu={shouldResetMenu}
          expanded={expanded}
        >
          <Menu
            pages={page.children}
            level={level + 1}
            hasMultipleLevels={!!deeperLevelsExist}
            expanded={expanded}
          />
        </MenuAccordion>
      ) : (
        <MenuItem
          key={`menu-item-level-${level}-${index}`}
          page={page}
          isLastLevel={!hasChildren && !!deeperLevelsExist}
          level={level}
          expanded={expanded}
        />
      );
    })}
  </IonList>
);
